import React from 'react'
import PropTypes from 'prop-types'
import styles from './ToggleSwitch.module.scss'

const ToggleSwitch = ({
    leftText,
    rightText,
    leftHandler,
    rightHandler,
    leftImageActive,
    leftImageInactive,
    rightImageActive,
    rightImageInactive,
    controller,
}) => {
    const handleKeyDown = (e, isLeft) => {
        if (e.key === 'ArrowLeft' && !isLeft && !controller) {
            leftHandler()
        } else if (e.key === 'ArrowRight' && isLeft && controller) {
            rightHandler()
        }
    }

    return (
        <div className={styles.container} role='radiogroup' aria-label={`${leftText} or ${rightText}`}>
            <button
                type='button'
                role='radio'
                aria-checked={controller}
                className={`${styles.button} ${controller ? styles.button___active : ''}`}
                onClick={leftHandler}
                onKeyDown={e => handleKeyDown(e, true)}
            >
                <span className={`${styles.toggler} ${styles.toggler___left} ${controller ? styles.toggler___active : ''}`} />
                {leftText}
                <img src={controller ? leftImageActive : leftImageInactive} alt='' />
            </button>
            <button
                type='button'
                role='radio'
                aria-checked={!controller}
                className={`${styles.button} ${controller ? '' : styles.button___active}`}
                onClick={rightHandler}
                onKeyDown={e => handleKeyDown(e, false)}
            >
                <span className={`${styles.toggler} ${styles.toggler___right} ${controller ? '' : styles.toggler___active}`} />
                {rightText}
                <img src={controller ? rightImageInactive : rightImageActive} alt='' />
            </button>
        </div>
    )
}

ToggleSwitch.propTypes = {
    leftText: PropTypes.string,
    rightText: PropTypes.string,
    leftImageActive: PropTypes.string,
    leftImageInactive: PropTypes.string,
    rightImageActive: PropTypes.string,
    rightImageInactive: PropTypes.string,
    leftHandler: PropTypes.func,
    rightHandler: PropTypes.func,
    controller: PropTypes.bool,
}

export default ToggleSwitch
